import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'shared-forms-inputs-group',
    templateUrl: './forms-inputs-group.shared.component.html',
    styleUrls: ['./forms-inputs-group.shared.component.scss']
})
export class FormsInputsGroupComponent {
    @Input() public label: string;
    @Input() public single: boolean = false;
}
